/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom"; 
import { USER_ROLES, ACCT_PLAN_LEVELS } from "../../utils/constants";

import "./MyAccount.scss";

import HeaderDefault from "../../components/HeaderDefault";

import MyInformation from "./MyInformation";
import MyDevices from "./MyDevices";
import AccountInfo from "./AccountInfo";
import GroupInfo from "./GroupInfo";
import Notifications from "./Notifications";
import Settings from "./Settings";

const MY_INFO = "My Information";
const ACCT_INFO = "Account Information";
const GROUP_INFO = "Group Information";
const MY_DEVICES = "My Devices";
const NOTIFICATIONS = "App Notifications";
const SETTINGS = "Settings";

const MyAccount = () => {
  const { roleId, planLevel } = JSON.parse(sessionStorage.getItem("selfData"));
  const location = useLocation(); // Replaces response.name to track current route

  // Determines which content to render based on the current URL
  const renderPageForm = () => {
    switch (location.pathname) {
      case "/account/devices":
        return { headerText: MY_DEVICES, form: <MyDevices /> };
      case "/account/info":
        return { headerText: ACCT_INFO, form: <AccountInfo /> };
      case "/account/group":
        return { headerText: GROUP_INFO, form: <GroupInfo /> };
      case "/account/notifications":
        return { headerText: NOTIFICATIONS, form: <Notifications /> };
      case "/account/settings":
        return { headerText: SETTINGS, form: <Settings /> };
      default:
        return { headerText: MY_INFO, form: <MyInformation /> };
    }
  };

  const { headerText, form } = renderPageForm();

  return (
    <>
      <HeaderDefault />
      <div className="admin-layout">
        <div className="admin-menu">
          <h1 className="admin-title">My Account</h1>
          <ul className="admin-navbar">
            <li>
              <Link to="/account" className={location.pathname === "/account" ? "active" : ""}>
                {MY_INFO}
              </Link>
            </li>
            {roleId === USER_ROLES.USER ? (
              <li>
                <Link to="/account/info" className={location.pathname === "/account/info" ? "active" : ""}>
                  {ACCT_INFO}
                </Link>
              </li>
            ) : (
              <li>
                <Link to="/account/group" className={location.pathname === "/account/group" ? "active" : ""}>
                  {GROUP_INFO}
                </Link>
              </li>
            )}
            <li>
              <Link to="/account/devices" className={location.pathname === "/account/devices" ? "active" : ""}>
                {MY_DEVICES}
              </Link>
            </li>
            {planLevel !== ACCT_PLAN_LEVELS.BASIC && (
              <li>
                <Link
                  to="/account/notifications"
                  className={location.pathname === "/account/notifications" ? "active" : ""}
                >
                  {NOTIFICATIONS}
                </Link>
              </li>
            )}
            <li>
              <Link to="/account/settings" className={location.pathname === "/account/settings" ? "active" : ""}>
                {SETTINGS}
              </Link>
            </li>
          </ul>
        </div>
        <div className="admin-content">
          <div className="return-main">
            <Link to="/weather-display">Return to Main Screen</Link> 
          </div>
          <div className="inner-content">
            <h2>{headerText}</h2>
            {form}
          </div>
        </div>
      </div>
    </>
  );
};

MyAccount.propTypes = {
  router: PropTypes.object,
};

export default MyAccount;
